import Immutable from 'immutable'

import { actionTypes } from 'actions/actionTypes'

/**
 * Legacy code for setting non-rollouts Optimizely variants
 */

export const defaultFeatures = () => ({
  /*
   * TODO: remove default features
   * once something becomes default behavior, we should update the code rather than continue to drive it by feature flags
   */
  nextDayDeliveryPaintedDoor: {
    value: false,
  },
  goToMyGousto: {
    value: false,
  },
  goToMyDeliveries: {
    value: false,
  },
  ndd: {
    value: false,
  },
  sortMarketProducts: {
    value: false,
  },
  isMobileTopBannerAppAwarenessEnabled: {
    value: false,
  },
  isMobileMenuModalAppAwarenessEnabled: {
    value: false,
  },
  isMyGoustoBannerAppAwarenessEnabled: {
    value: false,
  },
  isGoustoOnDemandEnabled: {
    value: false,
  },
  isCorporateEnquiriesLinkVisible: {
    value: true,
  },
  beetrootsDiscountPromoBannerEnabled: {
    value: false,
  },
  beetrootsIsCheckoutRefactoredEnabled: {
    value: false,
  },
  beetrootsIsCuratedBoxesEnabled: {
    value: false,
  },
  isOneThreeFivePortionsEnabled: {
    value: false,
  },
  beetrootsIsBuildYourBoxCtaEnabled: {
    value: false,
  },
  beetrootsIsDiscountOptimisationEnabled: {
    value: false,
  },
  beetrootsIsLandOnMenuEnabled: {
    value: false,
  }
})

export const initialState = () => Immutable.fromJS(defaultFeatures())

export const featuresReducers = {
  features: (state = initialState(), action) => {
    switch (action.type) {
    case actionTypes.FEATURES_SET: {
      let interimState = state
      action.features.forEach((f) => {
        interimState = interimState.set(
          f.feature,
          Immutable.fromJS({
            value: f.value,
          }),
        )
      })

      return interimState
    }
    default:
      return state
    }
  },
}
